<div class="component-wrapper" [class.labelAside] = "labelAside">
  @if (!hideLabel) {
    <div id="label" [class.invalid]="!valueValid" [class.normalStyle]="normalFontStyle" [class.labelAside] = "labelAside" [class.disabled]="disabledLabel">
      @if (hasValidtor('require')) {
        <span class="reqIcon" [class.invalid]="!valueValid" id="require" #require> * </span>
      }
      <span>{{label}}</span>
      @if (hasValidtor('info')) {
        <mat-icon id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info', maxWidth: infoTooltipMaxWidth}"
          class="infoIcon" [class.invalid]="!valueValid" svgIcon="help.tooltip">
        </mat-icon>
      }
    </div>
  }
  <div id="inputWrapper" [class.invalid]="!valueValid" [class.filled]="input.value.length > 0" [class.disabled]="disabled" (focusout)="updateShowTooltip()" [style.height.px]="height"
    insTooltip [cfg]="{text: showTooltip ? value : '', position: {H: 'hCenter', V:'vTop'}, type: 'info'}">
    @if (showPrefix()) {
      <span class="prefixStr">{{prefixStr}}</span>
    }
    <input #input [type]="inputTypeForInput" autocomplete="off" class="input" placeholder="{{placeholder}}" [(ngModel)]="value" [disabled]="disabled" [class.disabled]="disabled" (paste)="onPaste($event)"/>
    @if (showSuffix() && valueValid) {
      <span class="suffixStr">{{suffixStr}}</span>
    }
    <div class="indicators">
      @if (isPassword && showRevealPasswordBtn && value) {
        <mat-icon class="warningIcon" [svgIcon]="inputTypeForInput == 'text' ? 'password.hide' : 'password.show'" (click)="setInputType()">
        </mat-icon>
      }
      @if (!valueValid) {
        <mat-icon class="warningIcon" svgIcon="alert.err"
          insTooltip [cfg]="{text: getValidtor('input').displayText, position: {H: 'hRight', V:'vBottom'}, type: 'err'}">
        </mat-icon>
      }
    </div>
  </div>
</div>

